module.exports = __webpack_public_path__ + "img/prometheus.dea7e508.png";